import { Reveal, ScrollMaskLine } from "./Reveal";
import { Download, ShoppingBag, ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  {
    icon: Download,
    tag: "Digital Downloads",
    title: "Template Kits & Assets",
    desc: "Ready-to-use social templates, print kits and brand starters — instant delivery.",
    cta: "Browse Downloads",
  },
  {
    icon: ShoppingBag,
    tag: "Beacon Shop",
    title: "The Beacon Shop",
    desc: "Curated goods, prints and creative products straight from the Lab.",
    cta: "Visit the Shop",
  },
];

export default function FromLab() {
  return (
    <section
      id="from-the-lab"
      data-testid="from-lab-section"
      className="relative py-28 md:py-40 bg-[#0b0618]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl tracking-tight">
            <ScrollMaskLine>From the</ScrollMaskLine>
            <ScrollMaskLine delay={0.1} className="text-[#C77DFF]">
              Lab
            </ScrollMaskLine>
          </h2>
          <Reveal delay={0.2} className="max-w-sm text-[#B5A6CC] md:text-right">
            Take a piece of the Lab home — downloads and products designed for
            makers and businesses alike.
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PRODUCTS.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 0.1}
              data-testid={`product-card-${i}`}
              className="group relative overflow-hidden rounded-3xl border border-[#2D1B4E] bg-[#120B24] p-8 md:p-12 transition-colors duration-500 hover:border-[#8A2BE2]"
            >
              <div className="pointer-events-none absolute -top-20 -right-20 h-52 w-52 glow-radial opacity-0 group-hover:opacity-70 transition-opacity duration-500" />
              <div className="relative">
                <div className="mb-8 grid h-14 w-14 place-items-center rounded-2xl bg-[#8A2BE2]/15 text-[#C77DFF]">
                  <p.icon size={26} />
                </div>
                <span className="text-xs uppercase tracking-[0.3em] text-[#C77DFF]">
                  {p.tag}
                </span>
                <h3 className="mt-3 font-display font-bold text-3xl md:text-4xl text-white">
                  {p.title}
                </h3>
                <p className="mt-4 text-[#B5A6CC] max-w-md leading-relaxed">
                  {p.desc}
                </p>
                <a
                  href="#contact"
                  data-testid={`product-cta-${i}`}
                  className="mt-8 inline-flex items-center gap-2 text-white font-medium link-underline"
                >
                  {p.cta}
                  <ArrowUpRight size={18} className="text-[#C77DFF]" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
